import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  section: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  price: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  },
  priceNote: {
    color: theme.colorPalette.beige_10_op_75,
    textTransform: 'uppercase'
  },
  plus: {
    color: theme.colorPalette.beige_10_op_75
  }
});

export default makeStyles(styles);
